import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=31f445b0"
import script from "./Notes.ts?vue&type=script&lang=ts&external"
export * from "./Notes.ts?vue&type=script&lang=ts&external"
import style0 from "./Notes.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports